import { render } from "./vCardPart.vue?vue&type=template&id=2fa1e889&scoped=true"
import script from "./vCardPart.vue?vue&type=script&lang=js"
export * from "./vCardPart.vue?vue&type=script&lang=js"

import "./vCardPart.vue?vue&type=style&index=0&id=2fa1e889&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa1e889"]])

export default __exports__